import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  blockName: PropTypes.string,
  content: PropTypes.string.isRequired,
};

const defaultProps = {
  blockName: '',
};

function Text(props) {
  return (
    <div
      className={props.blockName ? `${props.blockName}_wysiwyg` : ''}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
}

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export default Text;
